import { capitalizeFirstLetter } from "../utils/utils";

export default function Menu(props: { active: string, setActive: (value: React.SetStateAction<string>) => void, name: string, percentage?: number }) {

    return (
        <div className={"p-3 box-border rounded-t-xl flex-1 flex flex-col items-center justify-center cursor-pointer transition-all duration-500 hover:bg-blackOverlay dark:hover:bg-whiteOverlay " + (props.active === props.name ? "bg-blackOverlay dark:bg-whiteOverlay" : "")} onClick={() => props.setActive(props.name)}>
            <p className={"md:text-2xl xshort:text-base text-base " + (props.active === props.name ? "font-semibold" : "font-medium")}>{capitalizeFirstLetter(props.name)}</p>
        </div>
    );
}